import {
  FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_REQUEST,
  FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_SUCCESS,
  FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_FAILURE,
} from "./actionTypes";

export const fetchPodDocumentUploadDetailsListRequest = (
  url: string,
  payload: any,
) => ({
  type: FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_REQUEST,
  url,
  payload,
});

export const fetchPodDocumentUploadDetailsListSuccess = (payload: any) => ({
  type: FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_SUCCESS,
  payload: payload,
});

export const fetchPodDocumentUploadDetailsListFailure = (payload: any) => ({
  type: FETCH_POD_DOCUMENT_UPLOAD_DETAILS_LIST_FAILURE,
  payload: payload,
});
